import React, { useState, useCallback, useRef } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, CircularProgress } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import styled from 'styled-components';
import { Colors } from '../constants';

const StyledTextField = styled(TextField)`
  .MuiInputBase-input::placeholder {
    color: ${Colors.TEXT_PRIMARY};
    opacity: 1;
  }
  &:hover {
    .MuiInputBase-input::placeholder {
      color: ${Colors.PRIMARY_BLUE};
      opacity: 1;
    }
  }
`;

const PopupIconWrapper = styled.span`
  display: flex;
  align-items: center;

  svg {
    color: ${Colors.PRIMARY_BLUE};
  }
`;

const AutoCompleteInput = ({
  options,
  value,
  onChange,
  placeholder,
  getOptionLabel,
  loading,
  onInputChange,
  onLoadMore,
  hasMore,
  getOptionSelected,
}) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const listboxRef = useRef(null);

  const handleScroll = useCallback(
    (event) => {
      const listbox = event.currentTarget;
      const isNearBottom = listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 8;
      if (isNearBottom && hasMore && !loading && onLoadMore) {
        onLoadMore();
      }
    },
    [hasMore, loading, onLoadMore],
  );

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={getOptionLabel || ((option) => option)}
      getOptionSelected={getOptionSelected}
      value={value}
      onChange={onChange}
      onOpen={() => setPopupOpen(true)}
      onClose={() => setPopupOpen(false)}
      onInputChange={onInputChange}
      loading={loading}
      ListboxProps={{
        ref: listboxRef,
        onScroll: onLoadMore ? handleScroll : undefined,
      }}
      popupIcon={(
        <PopupIconWrapper>
          {popupOpen ? <ExpandLess /> : <ExpandMore />}
        </PopupIconWrapper>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          variant="outlined"
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutoCompleteInput;
